var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a-card',[_c('div',{ref:"qTreeContainerRef"},[_c('div',{ref:"selectRef"},[_vm._t("select")],2),_c('div',{ref:"treeRef",staticClass:"q-mt-10 q-tree-container"},[_vm._t("tree")],2)])])
}
var staticRenderFns = []

export { render, staticRenderFns }